import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["filter"]
  }

  connect() {
    this.params = new URLSearchParams(window.location.search)
    this.params.delete('page')
    this.params.delete('task_id') // task_id is managed by task_autoloader, not filters
    this.timeout = null
    this.restoreFocus();
    this.initializeSelect2();
  }

  filter(event) {
    event.preventDefault();
    clearTimeout(this.timeout);

    if (event.type === "change") {
      this.handleFilter(event);
    } else {
      this.timeout = setTimeout(() => {this.handleFilter(event)}, 500);
    }
  }


  handleFilter(event) {
    const name = event.target.name
    const value = event.target.value

    if(name == 'date_range') {
      this.handleDate(value)
    } else if (event.target.selectedOptions && event.target.multiple) {
      this.handleMultiselect(name, value, event.target.selectedOptions)
    }
    else if (event.target.type === 'checkbox') {
      this.handleCheckbox(name, event.target.checked)
    }
    else {
      this.handleSingleValue(name, value)
    }

    this.visitUrl(event.target.dataset.url)
  }

  visitUrl(targetUrl) {
    if (targetUrl) {
      fetch(`${targetUrl}?${this.params.toString()}`, {
        headers: {
          "Content-Type": 'text/vnd.turbo-stream.html',
          'Accept': "text/vnd.turbo-stream.html"
        }
      })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
      .catch(error => console.error('Error:', error))
    } else {
      Turbo.visit(`${window.location.pathname}?${this.params.toString()}`)
    }
  }

  handleDate(value) {
    const dates = value.split(' - ')
    if(value === "") {
      this.params.set('start_date')
      this.params.set('end_date')
    }
    this.params.set('start_date', dates[0])
    this.params.set('end_date', dates[1])
  }

  handleMultiselect(name, value, options) {
    var allParams = this.params.getAll(name)
    this.params.delete(name);
    var selectedOptions = Array.from(options)
    selectedOptions.forEach(option => {
      this.params.append(name, option.value)
    })
  }

  handleSingleValue(name, value) {
    if(value != "") this.params.set(name, value)
    else this.params.delete(name);
  }

  // Handle checkbox filtering with optional preservation of unchecked state.
  //
  // By default, unchecked checkboxes have their params deleted (existing behavior)
  // Add data-preserve-unchecked="true" to keep unchecked checkboxes in URL params
  // This prevents checkboxes that default to checked from reverting when unchecked.
  handleCheckbox(name, checked) {
    if(checked) {
      this.params.set(name, this.element.dataset.checkedValue || 'true')
    } else {
      if(this.element.dataset.preserveUnchecked) {
        this.params.set(name, this.element.dataset.uncheckedValue || 'false')
      } else {
        this.params.delete(name)
      }
    }
  }

  restoreFocus() {
    if(!this.hasFilterTarget) { return }
    if(this.filterTarget.name !== 'q') { return ; }
    const valueLength = this.filterTarget.value.length;
    this.filterTarget.focus();

    if (this.filterTarget.setSelectionRange) {
      this.filterTarget.setSelectionRange(valueLength, valueLength);
    } else if (this.filterTarget.createTextRange) { // older browsers
      const range = this.filterTarget.createTextRange();
      range.collapse(true);
      range.moveEnd('character', valueLength);
      range.moveStart('character', valueLength);
      range.select();
    }
  }

  // Restore selection from URL params, if any
  initializeSelect2() {
    const $element = $(this.element);
    const selectedValues = this.params.getAll(this.element.name);

    if (selectedValues.length) {
      $element.val(selectedValues);
    }
  }
}
